<script setup lang="ts">
import { CheckDone01Icon, FileCode02Icon } from "@gohighlevel/ghl-icons/24/outline";
import { UIInput, UIModal, UIModalFooter, UIModalHeader } from "@gohighlevel/ghl-ui";
import { Editor } from "@tiptap/vue-3";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
interface Props {
  editor: Editor;
}

defineProps<Props>();

const htmlContent = ref<string>("");
const modal = ref<{ sourceCode: boolean }>({ sourceCode: false });

const toggleSourceCode = (editor?: Editor) => {
  modal.value.sourceCode = !modal.value.sourceCode;
  if (modal.value.sourceCode && editor) {
    htmlContent.value = editor.getHTML();
  }
};

const updateSourceCode = (editor?: Editor) => {
  if (editor) {
    editor.commands.setContent(htmlContent.value, true);
  }
  modal.value.sourceCode = false;
};
</script>

<template>
  <div>
    <div
      class="ml-1 flex cursor-pointer items-center text-center"
      @click="() => toggleSourceCode(editor)"
    >
      <FileCode02Icon class="h-4 w-4" />
    </div>
  </div>
  <div>
    <UIModal
      v-model:show="modal.sourceCode"
      class-name="fixed top-10 left-0 right-0 flex justify-center"
      :z-index="9999"
    >
      <template #header>
        <UIModalHeader
          id="form_builder-modal_header-source_code"
          type="primary"
          :title="t('textEditor.sourceCode')"
          description=""
          :icon="CheckDone01Icon"
          @close="() => toggleSourceCode(editor)"
        />
      </template>
      <UIInput
        id="form_builder-input-source_code_content"
        v-model="htmlContent"
        placeholder=""
        type="textarea"
        :rows="10"
      />
      <template #footer>
        <UIModalFooter
          id="form_builder-modal_footer-source_code"
          :negative-text="$t('common.cancel')"
          :positive-text="$t('common.save')"
          :loading="false"
          :disabled="false"
          type="primary"
          @positive-click="() => updateSourceCode(editor)"
          @negative-click="() => toggleSourceCode(editor)"
        />
      </template>
    </UIModal>
  </div>
</template>
